import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SubSink } from "subsink";
import { ChaseDetailStateService } from "../../../../member/chase-detail/chase-detail-state.service";
import { ChaseDetailService } from "../../../../member/chase-detail/chase-detail.service";
import { ProductType } from "../../../../project/new-project/product-type.enum";
import { ChaseDetailForAuditItem } from "../../../chase-detail-for-audit-item.model";
import { AuditQueryChartService } from "./audit-query-chart.service";

@Component({
  selector: "app-audit-query-chart",
  templateUrl: "./audit-query-chart.component.html",
  styleUrls: ["./audit-query-chart.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditQueryChartComponent implements OnInit, OnDestroy {
  private sink = new SubSink();
  private unsubscribe = new Subject();
  chaseDetails: ChaseDetailForAuditItem;
  isVisible = false;

  constructor(
    private readonly auditQueryChartService: AuditQueryChartService,
    private chaseDetailStateService: ChaseDetailStateService,
    private chaseDetailService: ChaseDetailService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }

  get iframeSrc(): string {
    return `app/chases/${this.chaseDetails?.chaseId}?auditPackageId=${this.chaseDetails?.auditPackageId}&auditPackageItemId=${this.chaseDetails?.auditPackageItemId}&numeratorId=${this.chaseDetails?.numeratorId}`;
  }

  get classes(): string {
    return "iframe_react_container--coding_screen";
  }

  get isHedisNextGen(): boolean {
    return this.chaseDetails?.templateId >= ProductType.FULL_WORKFLOW_V2025_NEWGEN;
  }

  ngOnInit() {
    this.auditQueryChartService.setChaseDetails(null);

    this.sink.add(
      this.auditQueryChartService.auditChaseDetails
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(data => {
          this.chaseDetails = data;
          if (data != null) {
            this.getChaseDetailState();
            this.isVisible = this.isHedisNextGen;
          }
          this.changeDetector.markForCheck();
        })
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private getChaseDetailState(): void {
    this.chaseDetailService.getChaseDetail(this.chaseDetails.chaseId)
      .subscribe(chaseDetail => {
        this.chaseDetailStateService.setData({
          ...chaseDetail,
        });
      });
  }

}
